import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateItemInCollection } from "directus/src/operations";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export const useUpdatePullRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ pullRequestId, values }) => {
      const payload = buildPayload(values);
      return await updateItemInCollection("pull_requests", pullRequestId, payload);
    },

    onSuccess: () => {
      toast.success("Pull request updated successfully");
      invalidateAllQueries();
    },

    onError: (error) => {
      toast.error(error.message || "Failed to update pull request");
      console.error(error);
    },
  });
};
